/* eslint-disable @typescript-eslint/naming-convention */
export const SafeMFASystem = 'd7b7eeb3-6156-4109-97cb-668b02b5f6ac';
export const ProtectedResources = '760531d7-f6a0-4fc8-819a-f72b05d7c261';
export const Invitations = '59c24bb9-2b85-4ecc-b4b2-2515ff1f9c6b';
export const Settings = '283b5c91-f540-4f28-901d-5105c09805f2';
